import { Controller } from 'stimulus'

const template = (id) => `
<li class="ingredient-item">
  <input name="ingredients[${id}][ingredient]" />
  <input name="ingredients[${id}][measure]" />
  <button class="ingredient-item-close" data-action="click->formulas#remove"><i class="far fa-trash"></i></buton>
</li>`

const id = () => Math.round(Math.random() * 100000)

export default class FormulasController extends Controller {
  static targets = ['ingredients']

  addIngredient(evt) {
    evt.preventDefault()
    this.ingredientsTarget.insertAdjacentHTML('beforeend', template(id()))
  }

  remove(evt) {
    evt.preventDefault()
    evt.currentTarget.parentNode.remove()
    return false
  }
}
